import User from "@/models/User.js";

export default {
	state: () => ({
		serviroutes_permissions: [],
		configjsonRequiredNotify: false,
		configjsonRequired: "",
	}),
	actions: {
		getPermissions: async function ({state, commit}) {
			const userSession = new User();
			const user = await userSession.getUser();
			const permissionsList = user.serviroutes_permissions;
			commit("setPermissions", permissionsList);
		},
		setPermissions: function ({state, commit}, payload) {
			commit("setPermissions", payload);
		},
	},
	mutations: {
		setPermissions(state, permissions) {
			state.serviroutes_permissions = permissions;
		},
	},
	getters: {
		checkPermission: (state) => (name) => {
			return state.serviroutes_permissions.some((permission) => permission.permission_name === name);
		},
	},
};
